import { UserEditPage } from '@components'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/betausers_/$userId/edit/')({
  component: UserEditPage,
})
